import { CsvCell } from "ag-grid-community/dist/types/src/interfaces/exportParams";
import { AllTypeResourcesData } from "@/store/resources-grid/utils/types/resources";
import { ResourceType } from "@/services/cloudchipr.api";
import { getColumnDefByResourceType } from "@/components/pages/common/resources-ag-grid/components/column-defs/getColumnDefByResourceType";
import { stringifyResourceColumnDef } from "@/components/pages/common/resource-details/components/content/general-content/components/details/resource-details-general-content-details-generator/stringifyResourceColumnDef";

export const generateAllChildrenCSVData = (
  resources: AllTypeResourcesData[],
  paddingLength: number,
) => {
  if (!resources?.length) {
    return;
  }

  const resourceType = resources?.at(0)?.resource_type as ResourceType;

  if (!resourceType) {
    return;
  }

  const colDefs = getColumnDefByResourceType(resourceType);

  const headerData: CsvCell[] =
    colDefs?.map((colDef) => {
      let value = colDef.field ?? colDef.colId ?? "";

      if (typeof colDef.headerName === "string") {
        value = colDef.headerName;
      }

      return { data: { value: `#${value}` } };
    }) ?? [];

  const padding: CsvCell[] = Array(paddingLength)
    .fill(null)
    .map(() => ({ data: { value: "" } }));

  const result: CsvCell[][] = [[...padding, ...headerData]];

  resources.forEach((resource) => {
    const rowData: CsvCell[] =
      colDefs?.map((def) => {
        const value = stringifyResourceColumnDef(def, resource.resource, true);

        const usable = typeof value === "string" || typeof value === "number";

        return { data: { value: usable ? `${value ?? ""}` : "" } };
      }) ?? [];

    result.push([...padding, ...rowData]);

    const childrenData = generateAllChildrenCSVData(
      resource?.child_resource?.resources,
      paddingLength + headerData.length,
    );

    if (childrenData) {
      result.push(...childrenData);
    }
  });

  result.push(padding);

  return result;
};
